import * as React from "react";
const SvgFiRrHairClipper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hair-clipper_svg__a)">
      <path
        fill="#062147"
        d="M15.707 14.293a.999.999 0 1 1-1.414 1.414l-2-2a.999.999 0 1 1 1.414-1.414zm8 9.414a.997.997 0 0 1-1.414 0l-2.712-2.712a5.6 5.6 0 0 1-3.18.994 5.56 5.56 0 0 1-3.618-1.325c-4.432-3.781-7.834-6.852-10.111-9.13L.318 9.183a.999.999 0 1 1 1.414-1.414l1.275 1.275L4.05 8 2.812 6.727a1 1 0 1 1 1.434-1.394l1.218 1.253L6.55 5.5 5.312 4.227a1 1 0 1 1 1.434-1.394l1.218 1.253 1.078-1.078-1.275-1.275A.999.999 0 1 1 9.18.319l2.354 2.354c2.277 2.277 5.349 5.679 9.129 10.11 1.657 1.942 1.743 4.759.335 6.802l2.708 2.708a1 1 0 0 1 0 1.414M9.77 9.77a4.2 4.2 0 0 0 .564-5.23l-5.796 5.795c1.592 1.025 3.864.803 5.232-.565m9.175 9.175a3.606 3.606 0 0 0 .196-4.865c-2.342-2.746-4.406-5.09-6.171-7.007-.065 1.495-.647 2.972-1.786 4.11a6.15 6.15 0 0 1-4.095 1.802 254 254 0 0 0 6.992 6.157c1.412 1.207 3.55 1.119 4.864-.197"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hair-clipper_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHairClipper;
